export default "__VITE_ASSET__8ed92cd7__"